const _temp0 = require("../../intl/inlinealert/ar-AE.json");
const _temp1 = require("../../intl/inlinealert/bg-BG.json");
const _temp2 = require("../../intl/inlinealert/cs-CZ.json");
const _temp3 = require("../../intl/inlinealert/da-DK.json");
const _temp4 = require("../../intl/inlinealert/de-DE.json");
const _temp5 = require("../../intl/inlinealert/el-GR.json");
const _temp6 = require("../../intl/inlinealert/en-US.json");
const _temp7 = require("../../intl/inlinealert/es-ES.json");
const _temp8 = require("../../intl/inlinealert/et-EE.json");
const _temp9 = require("../../intl/inlinealert/fi-FI.json");
const _temp10 = require("../../intl/inlinealert/fr-FR.json");
const _temp11 = require("../../intl/inlinealert/he-IL.json");
const _temp12 = require("../../intl/inlinealert/hr-HR.json");
const _temp13 = require("../../intl/inlinealert/hu-HU.json");
const _temp14 = require("../../intl/inlinealert/it-IT.json");
const _temp15 = require("../../intl/inlinealert/ja-JP.json");
const _temp16 = require("../../intl/inlinealert/ko-KR.json");
const _temp17 = require("../../intl/inlinealert/lt-LT.json");
const _temp18 = require("../../intl/inlinealert/lv-LV.json");
const _temp19 = require("../../intl/inlinealert/nb-NO.json");
const _temp20 = require("../../intl/inlinealert/nl-NL.json");
const _temp21 = require("../../intl/inlinealert/pl-PL.json");
const _temp22 = require("../../intl/inlinealert/pt-BR.json");
const _temp23 = require("../../intl/inlinealert/pt-PT.json");
const _temp24 = require("../../intl/inlinealert/ro-RO.json");
const _temp25 = require("../../intl/inlinealert/ru-RU.json");
const _temp26 = require("../../intl/inlinealert/sk-SK.json");
const _temp27 = require("../../intl/inlinealert/sl-SI.json");
const _temp28 = require("../../intl/inlinealert/sr-SP.json");
const _temp29 = require("../../intl/inlinealert/sv-SE.json");
const _temp30 = require("../../intl/inlinealert/tr-TR.json");
const _temp31 = require("../../intl/inlinealert/uk-UA.json");
const _temp32 = require("../../intl/inlinealert/zh-CN.json");
const _temp33 = require("../../intl/inlinealert/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}